import { createActions, createReducer } from "reduxsauce"

//Action types e Creators
export const { Types, Creators } = createActions({
  chartClean: [],
  getChartLoading: [],
  getChartError: ['error'],
  getChartSuccess: ['chart'],
  sendChartLoading: [],
  sendChartSuccess: [],
  sendChartError: ['error'],
});

//Reducer Handlers
const INITIAL_STATE = {
  loading: false,
  error: '',
  chart: {
    tabelaMedida: undefined,
    nomeArquivo: '',
    dataInclusao: '',
  },
  sendChart: {
    loading: false,
    result: undefined,
  }
};

const clean = (state = INITIAL_STATE, action) => {
  return { ...INITIAL_STATE }
}

const loading = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true, error: undefined, chart: {} }
}

const error = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false, error: action.error.message, chart: {} }
}

const success = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false, error: undefined, chart: action.chart }
}

const sendLoading = (state = INITIAL_STATE, action) => {
  return { ...state, sendChart: { loading: true, result: undefined } }
}

const sendSuccess = (state = INITIAL_STATE, action) => {
  return { ...state, sendChart: { loading: false, result: true } }
}

const sendError = (state = INITIAL_STATE, action) => {
  return { ...state, sendChart: { loading: false, result: false } }
}

//Create Reducer
export default createReducer(INITIAL_STATE, {
  [Types.CHART_CLEAN]: clean,
  [Types.GET_CHART_LOADING]: loading,
  [Types.GET_CHART_ERROR]: error,
  [Types.GET_CHART_SUCCESS]: success,
  [Types.SEND_CHART_LOADING]: sendLoading,
  [Types.SEND_CHART_SUCCESS]: sendSuccess,
  [Types.SEND_CHART_ERROR]: sendError,
});